<template>
<div class="relative bg-black">
    <div class="h-56 bg-cyan-600 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2">
    <img class="h-full w-full object-cover" src="https://www.novatec-gmbh.de/wp-content/uploads/Augmented-und-Virtual-Reality_Mini-Bild-Detailseite-Faktenbox_Novatec_HR_Remote-Meeting_0054_20210729-e1664391797629.jpg" alt="" />
    </div>
    <div class="relative mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
    <div class="md:ml-auto md:w-1/2 md:pl-10">
        <p class="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">Career at Novatec</p>
        <p class="mt-3 text-lg text-gray-300">You like what you have read so far? They are exactly your topics? Find out about our open positions and how much fun it is to work for us on our careers page.</p>
        <div class="mt-8">
        <div class="inline-flex rounded-md shadow">
            <RouterLink to="/career" class="inline-flex items-center justify-center rounded-md border border-transparent bg-white px-5 py-3 text-base font-medium text-gray-900 hover:bg-gray-50">
            Become part of the team
            <i class="fa-solid fa-paper-plane -mr-1 ml-3 h-5 w-5 text-gray-400" aria-hidden="true" ></i>
            </RouterLink>
        </div>
        </div>
    </div>
    </div>
</div>
</template>